var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper p-d-flex p-flex-wrap p-ai-center p-my-1"},[_c('label',{staticClass:"label p-mr-3 p-my-1"},[_vm._v(_vm._s(_vm.label)+":")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }